<table class="book-preview-pages">
  <tbody>
  <tr>
    <td class="page-wrapper">
      <div class="book-preview-page" [style.width.px]="pageDisplayWidth + 18" [style.height.px]="pageDisplayHeight + 18">
        <div class="clipping-rect">
          <img #leftImage class="page-image" src="">
          <p *ngIf="leftPageNumber !== 0" class="loading-text" i18n="@@Loading Image">Loading Image</p>
          <!-- Spine line -->
          <div class="spine-line" style="position: absolute; right: 0; top: 9px; width: 1px; background-color: black;" [style.height.px]="pageDisplayHeight"></div>
          <!-- Trim cut lines -->
          <div class="cut-line vert-cut" style="left: 8px;"></div>
          <div class="cut-line hor-cut" style="top: 8px;"></div>
          <div class="cut-line hor-cut" style="bottom: 8px;"></div>
        </div>
      </div>
    </td>
    <td class="page-wrapper">
      <div class="book-preview-page" [style.width.px]="pageDisplayWidth + 18" [style.height.px]="pageDisplayHeight + 18">
        <div class="clipping-rect">
          <img #rightImage class="page-image" src="">
          <p *ngIf="rightPageNumber <= (book?.body?.numPages || 0)" class="loading-text" i18n="@@Loading Image">Loading Image</p>
          <!-- Spine line -->
          <div class="spine-line" style="position: absolute; left: 0; top: 9px; width: 1px; background-color: black;" [style.height.px]="pageDisplayHeight"></div>
          <!-- Trim cut lines -->
          <div class="cut-line vert-cut" style="right: 8px;"></div>
          <div class="cut-line hor-cut" style="top: 8px;"></div>
          <div class="cut-line hor-cut" style="bottom: 8px;"></div>
        </div>
      </div>
    </td>
  </tr>
  </tbody>
</table>

